import { ApolloError } from '@apollo/client';

import { useErpCareerSkillsQuery } from 'core/graphql';

import { ICareerSkill } from './careerModel';

// Stable empty fallback — see the note in `useCareerMembers`.
const EMPTY_SKILLS: ICareerSkill[] = [];

interface ICareerSkillsHook {
  skills: ICareerSkill[];
  loading: boolean;
  error?: ApolloError;
}

/**
 * Spec 0018 increment B — the skill reference list (`careerSkills`), used by
 * the vacancy-form multiselect. The whole catalogue is small, so it is fetched
 * once and filtered client-side inside the picker rather than round-tripping a
 * `search` per keystroke.
 */
export const useCareerSkills = (): ICareerSkillsHook => {
  const { data, loading, error } = useErpCareerSkillsQuery({
    fetchPolicy: 'cache-and-network',
  });

  return {
    skills: data?.careerSkills ?? EMPTY_SKILLS,
    loading,
    error,
  };
};
